@if (useRadio) {
  {{getOptionText()}} <br />
}
<a style="display:none;" #downloadLink target="_blank" href="" rel="noopener noreferrer"></a>
@for (file of files; track file; let last = $last) {
  <a (click)="downloadFile(file)">{{file.fileName}}</a>{{last == false ? ',' : ''}}
}